import {updateMeta} from '../helpers/meta.ts';
import {msg} from '@lit/localize';

export function updateTourMeta(tourName: string, doc: Document): void {
  updateMeta(
    {
      title: tourName
        ? `Tour ${tourName} | ${msg('SwitzerlandMobility')}`
        : msg('Tour creation'),
    },
    doc,
  );
}
